import React from 'react'

import { colors, H5, Stack, XStack } from '@zet/design-system'
import { CategoryHeaderProps } from '@zet/zet-prime'

export default function CategoryHeader({ title }: CategoryHeaderProps) {
  return (
    <XStack className="items-center">
      <H5 className={`text-[${colors.grays[80]}] font-bold`}>{title}</H5>
      <Stack className="flex-1 h-[2px] ml-3 bg-[#E0E0E0]" />
    </XStack>
  )
}
